import { render } from "./wxacode.vue?vue&type=template&id=a49dca0c&scoped=true"
import script from "./wxacode.vue?vue&type=script&lang=js"
export * from "./wxacode.vue?vue&type=script&lang=js"

import "./wxacode.vue?vue&type=style&index=0&id=a49dca0c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a49dca0c"]])

export default __exports__